<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
        <b-row v-if="!loading">
            <b-col>
                <component-header
                    :title="`Create Product - ${
                        catalogObj !== null ? catalogObj.name : ''
                    }`"
                    :hasSearch="false"
                    :hasReload="false"
                    :hasCreate="false"
                    :hasback="true"
                    @back-press="backNavigate"
                />
            </b-col>
            <b-col sm="12">
                <b-card>
                    <ValidationObserver v-slot="{ invalid }" ref="observer">
                        <div>
                            <b-card v-if="userRole === 'Tenant'">
                                <b-row>
                                    <b-col md="6">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Seller"
                                        >
                                            <eb-select
                                                type="text"
                                                :id="'selectSeller'"
                                                v-model="currentProvider"
                                                :options="partnerList"
                                                label="userName"
                                                placeholder="Select Seller"
                                                @input="changeSeller"
                                            ></eb-select>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card
                                v-if="
                                    userRole === 'Partner' && enableManufacturer
                                "
                            >
                                <b-row>
                                    <b-col md="6">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Manufacturer"
                                        >
                                            <eb-select
                                                type="text"
                                                :id="'selectmanufacturer'"
                                                v-model="currentProvider"
                                                :options="partnerList"
                                                label="userName"
                                                placeholder="Select Manufacturer"
                                                @input="changeManufacturer"
                                            ></eb-select>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card
                                v-if="
                                    catalogObj &&
                                    catalogObj.variations &&
                                    catalogObj.variations.length > 0
                                "
                            >
                                <b-row>
                                    <b-col md="6">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Product Type"
                                        >
                                            <eb-select
                                                type="text"
                                                :id="'selectPtype'"
                                                v-model="selectedProductType"
                                                :options="productTypes"
                                                label="name"
                                                placeholder="Select Product Type"
                                                @input="changeProductType"
                                            ></eb-select>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col md="6">
                                        <ValidationProvider
                                            rules="required"
                                            v-slot="{ errors }"
                                            name="Type"
                                        >
                                            <eb-select
                                                type="text"
                                                :id="'selecttype'"
                                                v-model="selectedCreationType"
                                                :options="Types"
                                                label="name"
                                                placeholder="Select Type"
                                                @input="changeCreationType"
                                            ></eb-select>
                                            <span class="validate-error">{{
                                                errors[0]
                                            }}</span>
                                        </ValidationProvider>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card>
                                <b-row class="ml-5">
                                    <b-col
                                        sm="4"
                                        @click="() => showImagePicker('icon')"
                                    >
                                        <b-form-group
                                            label="Icon"
                                            label-for="Icon"
                                            id="Icon"
                                            :label-cols="7"
                                        ></b-form-group>
                                        <single-image
                                            :url="inputObj.images.icon"
                                            height="210px"
                                            width="180px"
                                            label="Browse for Icon"
                                        ></single-image>
                                    </b-col>
                                    <b-col
                                        sm="4"
                                        @click="
                                            () => showImagePicker('smallImage')
                                        "
                                    >
                                        <b-form-group
                                            label="Small Image"
                                            label-for="SmallImage"
                                            :label-cols="7"
                                            :horizontal="true"
                                        ></b-form-group>
                                        <single-image
                                            height="200px"
                                            width="180px"
                                            :url="inputObj.images.smallImage"
                                            label="Browse Small Image"
                                        ></single-image>
                                    </b-col>
                                    <b-col
                                        sm="4"
                                        @click="
                                            () => showImagePicker('bigImage')
                                        "
                                    >
                                        <b-form-group
                                            label="Big Image"
                                            label-for="BigImage"
                                            :label-cols="7"
                                            :horizontal="true"
                                        ></b-form-group>
                                        <single-image
                                            height="200px"
                                            width="180px"
                                            label="Browse for Big Image"
                                            :url="inputObj.images.bigImage"
                                        ></single-image>
                                    </b-col>
                                </b-row>
                                <!-- <b-row class="ml-5">
                <b-col sm="6">
                  <VueUploadMultipleImage
                    :data-images="alternateImages"
                    @change="setAlternateImages"
                  ></VueUploadMultipleImage>
                </b-col>
              </b-row> -->
                            </b-card>
                            <b-modal
                                v-model="showImageSelector"
                                centered
                                scrollable
                                size="lg"
                                style="width: 100px"
                            >
                                <div class="p-2">
                                    <b-row>
                                        <div class="md-3">
                                            <v-switch
                                                class="pa-2"
                                                color="blue"
                                                v-model="showLibrary"
                                            ></v-switch>
                                            <span class="mr-2 mb-1"
                                                >Pick From Library</span
                                            >
                                        </div>
                                        <div
                                            class="md-3 ml-auto"
                                            v-if="!showLibrary"
                                        >
                                            <b-button
                                                @click="
                                                    $refs.imageUploader.click()
                                                "
                                                >Select and Upload New</b-button
                                            >
                                            <input
                                                style="display: none"
                                                ref="imageUploader"
                                                type="file"
                                                @change="
                                                    uploadImageFromSelector
                                                "
                                            />
                                        </div>
                                    </b-row>
                                    <b-row
                                        v-if="showLibrary"
                                        style="
                                            max-height: 400px;
                                            overflow-x: auto;
                                            text-align: center;
                                        "
                                    >
                                        <b-col
                                            v-for="(d, i) in imageLibraryList"
                                            :key="i"
                                            md="2"
                                            @click="
                                                setImageFromLibrary(d.images)
                                            "
                                        >
                                            <img
                                                :src="
                                                    d.images[
                                                        libraryImageSelector
                                                    ]
                                                "
                                                style="object-fit: contain"
                                                height="100px"
                                                width="100%"
                                            />
                                            {{ d.title }}
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-modal>
                        </div>
                        <div
                            v-for="(entry, idx) in attributesMap.entries()"
                            :key="idx"
                        >
                            <b-row>
                                <b-col
                                    v-for="(item, index) in entry[1]"
                                    :key="index"
                                    :md="['Array'].includes(item.type) ? 12 : 6"
                                    :style="{
                                        display:
                                            item.type !== 'Array' ||
                                            (item.type === 'Array' &&
                                                valuesMap[
                                                    item.name ? item.name : ''
                                                ] &&
                                                valuesMap[item.name][0])
                                                ? 'block'
                                                : 'none',
                                    }"
                                >
                                    <field
                                        v-if="
                                            item.name !== 'days' &&
                                            item.name !== 'Type' &&
                                            item.name !== 'IsSellable' &&
                                            item.name !== 'b2bType'
                                        "
                                        :fieldType="item.type"
                                        :fieldName="item.name ? item.name : ''"
                                        :displayName="
                                            item.attributeLabel &&
                                            item.attributeLabel[tenantLang]
                                                ? item.attributeLabel[
                                                      tenantLang
                                                  ]
                                                : item.name
                                        "
                                        :onChange="
                                            updatingUI ? null : fieldChange
                                        "
                                        :value="item.defaultValue"
                                        :id="item._id"
                                        :isRequired="item.isRequired"
                                        :subFields="item.attributeItems"
                                        :level="0"
                                        :meta="[
                                            {
                                                name: item.name,
                                                type: item.type,
                                            },
                                        ]"
                                        :active="activeIndex"
                                        :index="index"
                                        :setActive="setActive"
                                        :UIConcern="item.UIConcern"
                                        :arrayChange="arrayChange"
                                        :valuesMap="valuesMap"
                                        :visibility="
                                            item.visibility
                                                ? item.visibility.onCreate
                                                : true
                                        "
                                    />
                                    <b-row
                                        v-else-if="
                                            item.name === 'days' ||
                                            item.name === 'fullTime'
                                        "
                                    >
                                        <b-col>
                                            <v-select
                                                v-model="inputObj['days']"
                                                :items="languages"
                                                item-text="name"
                                                return-object
                                                label="Select Days"
                                                multiple
                                                chips
                                                hint="What are the days for service"
                                                persistent-hint
                                            ></v-select>
                                        </b-col>
                                        <b-col>
                                            <v-switch
                                                color="indigo"
                                                v-model="inputObj['fullTime']"
                                                :label="`fullTime`"
                                            ></v-switch>
                                        </b-col>
                                    </b-row>
                                    <b-col v-if="item.name === 'IsSellable'">
                                        <v-switch
                                            color="indigo"
                                            v-model="inputObj['IsSellable']"
                                            :label="`IsSellable`"
                                        ></v-switch>
                                    </b-col>
                                    <card v-if="item.name === 'b2bType'">
                                        <label class="card-title">{{
                                            item.name
                                        }}</label>
                                        <b-col class="pb-1">
                                            <eb-select
                                                type="text"
                                                :id="'b2bType'"
                                                v-model="typeB2b"
                                                :options="selectB2b"
                                                :selected="typeB2b"
                                                label="text"
                                                placeholder="Select b2b Type"
                                            ></eb-select>
                                        </b-col>
                                    </card>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-if="isAddresscapture">
                            <b-row>
                                <b-col>
                                    <Card>
                                        <div class="wrap">
                                            <b-form-group>
                                                <p class="head">Location</p>
                                                <GmapAutocomplete
                                                    @place_changed="placechange"
                                                    :options="{
                                                        fields: [
                                                            'geometry',
                                                            'formatted_address',
                                                            'address_components',
                                                        ],
                                                    }"
                                                    class="mt-1 location-search"
                                                ></GmapAutocomplete>
                                            </b-form-group>
                                        </div>
                                    </Card>
                                </b-col>
                            </b-row>
                        </div>
                        <div
                            v-if="
                                catalogObj &&
                                catalogObj.variations &&
                                catalogObj.variations.length > 0 &&
                                selectedProductType.value === 'VARIABLE'
                            "
                        >
                            <a-divider />
                            <Variance
                                :isService="isService"
                                :varianceData="catalogVariations"
                                @change="onchangeVarianceData"
                                @changeDefault="changeDefault"
                            />
                        </div>
                        <a-divider />
                        <div class="form-actions" v-if="!submitted">
                            <router-link to="/item">
                                <button
                                    class="mr-1 btn btn-danger"
                                    variant="danger"
                                >
                                    <span>Cancel</span>
                                </button>
                            </router-link>
                            <button
                                class="mr-1 btn btn-primary"
                                variant="facebook"
                                @click="handleSumit"
                                :disabled="invalid"
                            >
                                <span>Save Item</span>
                            </button>
                        </div>
                        <div class="form-action" v-else>
                            <v-progress-circular
                                :indeterminate="true"
                                color="light-blue"
                            />
                        </div>
                    </ValidationObserver>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import cTable from "../base/Table.vue";
import Field from "@/components/Item/Field";
import Card from "../../components/Generics/Card.vue";
import ebSelect from "@/components/FormElements/Select.vue";
import Variance from "@/components/Variance/Variance.vue";
import locationMixins from "@/mixins/addressLocation";
import SingleImage from "../../components/Common/Image.vue";
import VueUploadMultipleImage from "@/components/FormElements/VueUploadMultipleImage";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "createItem",
    components: {
        cSwitch,
        cTable,
        field: Field,
        Card,
        SingleImage,
        ebSelect,
        Variance,
        VueUploadMultipleImage,
        ValidationObserver,
        ValidationProvider,
        ComponentHeader,
        AtomSpinner,
    },
    mixins: [locationMixins],
    data() {
        return {
            typeB2b: {},
            loading: false,
            selectedProductType: "NORMAL",
            selectedCreationType: "PRODUCT",
            libraryImageSelector: "",
            showImageSelector: false,
            updatingUI: false,
            showLibrary: false,
            productTypes: [
                {
                    name: "Normal",
                    value: "NORMAL",
                },
                {
                    name: "Variable",
                    value: "VARIABLE",
                },
            ],
            Types: [
                {
                    name: "Product",
                    value: "PRODUCT",
                },
                {
                    name: "Service",
                    value: "SERVICE",
                },
            ],
            enableManufacturer: false,
            currentProvider: "",
            isAddresscapture: false,
            catalogObj: null,
            alternateImages: [],
            inputObj: {
                Name: "",
                description_summary: "",
                provider: null,
                catalogId: "",
                images: {
                    icon: "",
                    smallImage: "",
                    bigImage: "",
                    alternateImages: [],
                },
            },
            languages: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
            ],
            externalAttribute: [],
            attributesMap: new Map(),
            valuesMap: {},
            activeIndex: null,
            submitted: false,
            applyFieldChange: false,
        };
    },
    props: {
        context: {
            type: String,
        },
    },
    methods: {
        ...mapActions({
            Getpartnerlist: "partner/fetchPartnersList",
            getImageLibraryList: "catalog/listImageLibrary",
            createLibrary: "catalog/createImageLibrary",
            getPartnerPaymentPreferencesAction:
                "partner/getPartnerPaymentPreferencesAction",
        }),
        backNavigate() {
            if (this.userRole === "Tenant") {
                this.$router.push({
                    name: "partner-item",
                    params: { id: this.partnerAllData._id },
                });
            } else {
                this.$router.push("/item");
            }
        },
        showImagePicker(selector) {
            this.libraryImageSelector = selector;
            this.showImageSelector = true;
        },
        uploadImageFromSelector(e) {
            const file = e.target.files[0];
            if (!e.target.files[0].type.match("image.*")) {
                this.invalid = true;
                this.$toasted.error("Invalid File format");
                return;
            }
            const reader = new FileReader();
            reader.onload = (e) => {
                const image = e.target.result;
                this.image = image;
                this.uploadImage(this.libraryImageSelector, image);
                this.$refs["imageUploader"].value = "";
            };
            reader.readAsDataURL(file);
        },
        changeIcon(e) {
            this.uploadImage("icon", e);
        },
        changeSmallImage(e) {
            this.uploadImage("smallimage", e);
        },
        changeBigImage(e) {
            this.uploadImage("largeimage", e);
        },
        setAlternateImages(images) {
            this.inputObj.images.alternateImages = images.map((i) => ({
                image: i,
            }));
        },
        setImageFromLibrary(images) {
            this.inputObj.images[this.libraryImageSelector] =
                images[this.libraryImageSelector];
            this.libraryImageSelector = "";
            this.showImageSelector = false;
        },
        createLibraryItem() {
            alert("Implement Library Creator");
        },
        // upload images to the S3 bucket
        async uploadImage(type, image) {
            this.showImageSelector = false;
            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: ["seller", "items"],
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    if (res) {
                        this.clearCustomToast();
                        if (type === "icon") {
                            this.inputObj.images.icon = res.data.fileUrl;
                        } else if (type === "smallImage") {
                            this.inputObj.images.smallImage = res.data.fileUrl;
                        } else {
                            this.inputObj.images.bigImage = res.data.fileUrl;
                        }
                    }
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        onchangeVarianceData(data) {
            this.inputObj.variations = data;
        },
        async getCatalog() {
            await this.$store
                .dispatch("catalog/fetchCatalogById", this.inputObj.catalogId)
                .then((result) => {
                    if (result.status !== 0) {
                        this.catalogObj = result.response;
                        let typeSet = new Set([
                            "String",
                            "Number",
                            "Object",
                            "Array",
                            "Boolean",
                        ]);
                        const default_str_attributes = [
                            {
                                type: "String",
                                name: "Title",
                                _id: "9",
                            },
                        ];
                        let attributesMap = new Map([
                            ["String", default_str_attributes],
                            ["Number", []],
                            ["Object", []],
                            ["Array", []],
                            ["Boolean", []],
                        ]);
                        let valuesMap = {};
                        valuesMap.Title = "";
                        result.response.externalAttributes.forEach((item) => {
                            if (
                                item.attributeRef &&
                                item.attributeRef.attributeName !== "Address" &&
                                item.attributeRef.attributeName !== "State" &&
                                item.attributeRef.attributeName !== "Country" &&
                                item.attributeRef.attributeName !== "City" &&
                                item.attributeRef.attributeName !== "Area" &&
                                item.attributeRef.attributeName !== "Lat" &&
                                item.attributeRef.attributeName !== "Lng"
                            ) {
                                if (
                                    item.attributeRef.attributeName ===
                                    "sellerContact"
                                ) {
                                    item.defaultValue =
                                        this.$currentUserData.phone;
                                }
                                if (
                                    item.attributeRef.attributeName ===
                                    "IsSellable"
                                ) {
                                    this.inputObj["IsSellable"] = true;
                                }
                                let type = item.attributeRef.attributeValueType;
                                let name = item.attributeRef.attributeName;
                                if (typeSet.has(type)) {
                                    let attObj = {
                                        ...item,
                                        ...item.attributeRef,
                                        type,
                                        name,
                                    };
                                    attributesMap.set(
                                        type,
                                        attributesMap
                                            .get(type)
                                            .concat([attObj]),
                                    );
                                    if (["String", "Number"].includes(type))
                                        valuesMap[name] = "";
                                    else if (type === "Boolean") {
                                        valuesMap[name] = false;
                                        this.inputObj[name] = false;
                                    } else if (type === "Object")
                                        valuesMap[name] = {};
                                    else if (type === "Array") {
                                        if (
                                            ["Checkbox"].includes(
                                                attObj.UIConcern,
                                            )
                                        )
                                            valuesMap[name] =
                                                attObj.attributeItems;
                                        else if (attObj.UIConcern === "Radio")
                                            valuesMap[name] = null;
                                        else if (attObj.UIConcern === "Select")
                                            valuesMap[name] = [];
                                        else if (
                                            attObj.UIConcern === "Object"
                                        ) {
                                            let temp = {};
                                            for (
                                                let i = 0;
                                                i <
                                                Object.keys(
                                                    attObj.attributeItems,
                                                ).length;
                                                i++
                                            ) {
                                                let key =
                                                    attObj.attributeItems[i]
                                                        .attributeName;
                                                temp[key] = "";
                                            }
                                            valuesMap[name] = [temp];
                                        }
                                    }
                                }
                            } else if (
                                item.attributeRef.attributeName === "Address"
                            ) {
                                this.isAddresscapture = true;
                            }
                        });
                        this.attributesMap = attributesMap;
                        this.valuesMap = valuesMap;
                    }
                });
        },
        fieldChange(data) {
            if (this.updatingUI) return;

            if (data.meta[0].name === "Name") {
                this.inputObj.Name = data.value;
                this.inputObj.description_summary = data.value;
            }
            // if (this.inputObj.ToDate) {
            //   this.inputObj.ToDate = data.value;
            //   this.inputObj.FromDate = data.value;
            // }
            else {
                if (
                    data.meta[0].type === "String" &&
                    data.meta[0].name !== "Title"
                ) {
                    this.inputObj[data.meta[0].name] = data.value;
                } else if (data.meta[0].type === "Number") {
                    this.inputObj[data.meta[0].name] =
                        typeof data.value === "string"
                            ? Number(data.value)
                            : data.value;
                } else if (data.meta[0].type === "Boolean") {
                    this.inputObj[data.meta[0].name] = data.value;
                } else if (data.meta[0].type === "Object") {
                    this.inputObj[data.meta[0].name] = data.value;
                }
            }
            const PriceDiff =
                this.inputObj["Price"] - this.inputObj["Deal Price"];

            if (
                typeof this.inputObj["Deal Price"] !== undefined &&
                (data.meta[0].type === "String" ||
                    data.meta[0].type === "Number")
            ) {
                if (!this.inputObj["Price"]) return;
                if (data.meta[0].name === "Discount(%)") {
                    this.updatingUI = true;
                    const discountAmount =
                        this.inputObj["Price"] *
                        (this.inputObj["Discount(%)"] / 100);

                    const discountedAmount =
                        this.inputObj["Price"] - discountAmount;
                    this.inputObj["Discount"] =
                        this.inputObj["Price"] - discountedAmount;
                    if (discountedAmount != this.inputObj["Deal Price"]) {
                        this.inputObj["Deal Price"] = discountedAmount;
                        // delete this.inputObj["Discount"];
                        if (PriceDiff != discountAmount) {
                            this.setUiUpdate();
                        }
                    }
                    setTimeout(() => {
                        this.updatingUI = false;
                    }, 1000);
                } else if (data.meta[0].name === "Discount") {
                    this.updatingUI = true;
                    const discountAmount =
                        this.inputObj["Price"] - this.inputObj["Discount"];
                    this.inputObj["Discount(%)"] = (
                        (this.inputObj["Discount"] / this.inputObj["Price"]) *
                        100
                    ).toFixed(2);
                    if (discountAmount != this.inputObj["Deal Price"]) {
                        this.inputObj["Deal Price"] = discountAmount;
                        if (PriceDiff != discountAmount) {
                            this.setUiUpdate();
                        }
                    }
                    setTimeout(() => {
                        this.updatingUI = false;
                    }, 1000);
                }
            }
        },
        setUiUpdate() {
            this.attributesMap = new Map([
                [
                    "String",
                    this.attributesMap.get("String").map((x) => {
                        if (x.attributeName === "Deal Price") {
                            x.defaultValue = this.inputObj["Deal Price"];
                        }
                        if (x.attributeName === "Discount") {
                            x.defaultValue = this.inputObj["Discount"];
                        }
                        if (x.attributeName === "Discount(%)") {
                            x.defaultValue = this.inputObj["Discount(%)"];
                        }
                        return x;
                    }),
                ],
                [
                    "Number",
                    this.attributesMap.get("Number").map((x) => {
                        if (x.attributeName === "Deal Price") {
                            x.defaultValue = this.inputObj["Deal Price"];
                        }
                        if (x.attributeName === "Discount") {
                            x.defaultValue = this.inputObj["Discount"];
                        }
                        if (x.attributeName === "Discount(%)") {
                            x.defaultValue = this.inputObj["Discount(%)"];
                        }
                        return x;
                    }),
                ],
                ["Object", this.attributesMap.get("Object")],
                ["Array", this.attributesMap.get("Array")],
                ["Boolean", this.attributesMap.get("Boolean")],
            ]);
        },
        changeDefault(val) {
            if (val) {
                this.attributesMap = new Map([
                    [
                        "String",
                        this.attributesMap.get("String").map((x) => {
                            if (
                                x.attributeName ===
                                Object.keys(val.attributes)[0]
                            ) {
                                x.defaultValue =
                                    val.attributes[
                                        Object.keys(val.attributes)[0]
                                    ];
                            }
                            if (
                                x.attributeName === "Deal Price" &&
                                val.DealPrice > 0
                            ) {
                                x.defaultValue = val.DealPrice;
                            }
                            if (
                                x.attributeName === "Discount" &&
                                val.Discount > 0
                            ) {
                                x.defaultValue = val.Discount;
                            }
                            if (
                                x.attributeName === "Discount(%)" &&
                                val.DiscountPercentage > 0
                            ) {
                                x.defaultValue = val.DiscountPercentage;
                            }
                            if (x.attributeName === "Inventory") {
                                x.defaultValue = val.Inventory;
                            }
                            if (x.attributeName === "StockCount") {
                                x.defaultValue = val.StockCount;
                            }

                            return x;
                        }),
                    ],
                    [
                        "Number",
                        this.attributesMap.get("Number").map((x) => {
                            if (
                                x.attributeName === "Deal Price" &&
                                val.DealPrice > 0
                            ) {
                                x.defaultValue = val.DealPrice;
                            }
                            if (
                                x.attributeName === "Price" &&
                                val.DealPrice > 0
                            ) {
                                x.defaultValue = val.Price;
                            }
                            if (x.attributeName === "Discount") {
                                x.defaultValue = val.Discount;
                            }
                            if (
                                x.attributeName === "Discount(%)" &&
                                val.DiscountPercentage > 0
                            ) {
                                x.defaultValue = val.DiscountPercentage;
                            }
                            if (x.attributeName === "StockCount") {
                                x.defaultValue = val.StockCount;
                            }
                            return x;
                        }),
                    ],
                    ["Object", this.attributesMap.get("Object")],
                    ["Array", this.attributesMap.get("Array")],
                    ["Boolean", this.attributesMap.get("Boolean")],
                ]);
            }
        },
        async handleSumit() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;
            if (
                !this.inputObj.images.icon ||
                !this.inputObj.images.smallImage ||
                !this.inputObj.images.bigImage
            ) {
                this.$swal({
                    title: "Error",
                    text: "Upload all images",
                    type: "error",
                });
                return;
            }
            this.inputObj["b2bType"] = `${this.typeB2b.value}`;
            let payload = {
                ...this.valuesMap,
                ...this.inputObj,
            };

            // Casting select fields
            Object.keys(this.valuesMap).forEach((key) => {
                let tempItem = this.valuesMap[key];
                if (
                    Array.isArray(tempItem) &&
                    tempItem.length > 0 &&
                    tempItem[0] &&
                    tempItem[0].value
                ) {
                    payload[key] = tempItem.map((v) => v.value);
                }
            });
            // casting descipriton summary
            if (this.inputObj.hasOwnProperty("IsSellable")) {
                this.inputObj.IsSellable
                    ? (this.inputObj.IsSellable = "TRUE")
                    : (this.inputObj.IsSellable = "FALSE");
            }
            payload.description_summary = payload.Name;
            if (this.inputObj.ToDate) {
                payload.FromDate = this.inputObj.FromDate;
                payload.ToDate = this.inputObj.ToDate;
            }

            delete payload.Title;
            this.submitted = true;
            // variance data logic
            let variations = [];
            if (
                this.inputObj.variations &&
                this.inputObj.variations.length > 0 &&
                !this.isService
            ) {
                this.inputObj.variations.map((obj) => {
                    let filteredobj = {
                        attributes: obj.attributes,
                        isDefault: obj.isDefault,
                        Price: +obj.Price,
                        Discount: +obj.Discount,
                        //DiscountPercentage: obj.DiscountPercentage,
                        DealPrice: +obj.DealPrice,
                    };

                    // let filteredobj1 = {
                    //   attributes: obj.attributes,
                    //   isDefault: obj.isDefault,
                    //   Price: +obj.Price,
                    //   //Discount: obj.Discount,
                    //   DiscountPercentage: obj.DiscountPercentage,
                    //   DealPrice: obj.DealPrice,
                    // };
                    if (!obj.Discount) {
                        filteredobj.Discount = 0;
                        filteredobj.DiscountPercentage = obj.DiscountPercentage;
                        // variations.push(filteredobj1);
                    }
                    if (!obj.DiscountPercentage) {
                        filteredobj.Discount = +obj.Discount;
                    }
                    variations.push(filteredobj);
                });

                // this.inputObj.variations = [];
                // this.inputObj.variations = variations;
            } else if (
                this.inputObj.variations &&
                this.inputObj.variations.length > 0
            ) {
                this.inputObj.variations.map((obj) => {
                    let filteredobj = {
                        attributes: obj.attributes,
                        isDefault: obj.isDefault,
                        slotLimit: obj.slotLimit,
                        Price: +obj.Price,
                    };
                    variations.push(filteredobj);
                });
            }
            this.inputObj.variations = [];
            this.inputObj.variations = variations;
            if (this.addressObj.data && this.isAddresscapture) {
                let fields = Object.keys(this.addressObj.data);
                fields.map((f) => {
                    if (f !== "zip") {
                        this.inputObj[f] = this.addressObj.data[f];
                    }
                });
                this.inputObj.Lng = this.addressObj.Lng;
                this.inputObj.Lat = this.addressObj.Lat;
                this.inputObj.Address = {
                    Lng: this.inputObj.Lng,
                    Lat: this.inputObj.Lat,
                    City: this.inputObj.City,
                    State: this.inputObj.State,
                    Country: this.inputObj.Country,
                    Address: this.addressObj.address,
                };
                this.inputObj.Area = this.addressObj.address;
            } else if (this.isAddresscapture) {
                this.inputObj.City = this.itemObj.Address.City;
                this.inputObj.Country = this.itemObj.Address.Country;
                this.inputObj.State = this.itemObj.Address.State;
                this.inputObj.Lat = this.itemObj.Address.Lat;
                this.inputObj.Lng = this.itemObj.Address.Lng;
                this.inputObj.Address = {
                    Lng: this.inputObj.Lng,
                    Lat: this.inputObj.Lat,
                    City: this.inputObj.City,
                    State: this.inputObj.State,
                    Country: this.inputObj.Country,
                    Address: this.itemObj.Address.Address,
                };
                this.inputObj.Area = payload.Address.Address;
            }
            this.inputObj.isDeleted = false;
            if (
                this.inputObj.variations &&
                this.inputObj.variations.length > 0 &&
                !this.isService
            ) {
                this.inputObj.variations.map((object) => {
                    if (object.isDefault) {
                        this.inputObj.Price = +object.Price;
                        Object.keys(object.attributes).map((key) => {
                            this.inputObj[key] = object.attributes[key];
                        });
                    }
                });
            } else if (
                this.inputObj.variations &&
                this.inputObj.variations.length > 0
            ) {
                this.inputObj.days = this.inputObj.days.join(",");
                this.inputObj.variations.map((object) => {
                    if (object.isDefault) {
                        Object.keys(object.attributes).map((key) => {
                            this.inputObj[key] = object.attributes[key];
                        });
                    }
                });
            }
            this.inputObj.Discount = this.inputObj.Discount;
            this.inputObj["Discount(%)"] = this.inputObj["Discount(%)"];
            this.inputObj.Price = this.inputObj.Price;

            this.$store
                .dispatch("item/createItem", {
                    ...this.inputObj,
                    // days: this.inputObj.days.join(","),
                })
                .then((result) => {
                    if (result.status === 1) {
                        this.$swal({
                            title: "Success",
                            text: "Item has been created successfully",
                            type: "success",
                        });
                        this.submitted = false;
                        this.$router.push("/item");
                    }
                })
                .catch((error) => {
                    this.$swal({
                        title: "Error",
                        text: error.message.message,
                        type: "error",
                    });
                    this.submitted = false;
                });
        },
        setActive(i) {
            this.activeIndex = this.activeIndex == i ? -1 : i;
        },
        arrayChange(data) {
            let { index, type, e, fieldName } = data;
            let { meta, value, action, arrObj } = data;
            let updateDoc = { ...this.valuesMap };
            let temp = this.valuesMap;
            let parent = temp;
            let path = "";
            for (let i = 0; i < meta.length; i++) {
                let item = meta[i],
                    { type, name } = item;
                if (["Object", "String", "Number", "Array"].includes(type)) {
                    parent = temp;
                    path = item.name;
                    temp = temp[item.name];
                }
            }
            let name = index;
            switch (type) {
                case "check": {
                    this.$set(temp[index], "checked", e.target.checked);
                    break;
                }
                case "select": {
                    this.$set(parent, fieldName, e);
                    break;
                }
                case "radio": {
                    this.$set(parent, fieldName, e);
                }
            }
            if (arrObj === true) {
                switch (action) {
                    case "change": {
                        this.$set(
                            parent,
                            path,
                            temp.map((item, idx) =>
                                idx === index
                                    ? {
                                          ...item,
                                          [fieldName]: e,
                                      }
                                    : item,
                            ),
                        );
                        break;
                    }
                    case "add": {
                        let tObj = {};
                        let keys = Object.keys(temp[0]);
                        for (let i = 0; i < keys.length; i++) {
                            tObj[keys[i]] = "";
                        }
                        this.$set(parent, path, temp.concat([tObj]));
                    }
                    case "remove": {
                        temp.splice(index, 1);
                    }
                }
            }
        },
        changeSeller(event) {
            this.inputObj.provider = this.currentProvider
                ? this.currentProvider._id
                : null;
        },
        changeProductType(event) {
            this.inputObj.productType = this.selectedProductType
                ? this.selectedProductType.value
                : "NORMAL";
        },
        changeCreationType(event) {
            this.inputObj.Type = this.selectedCreationType
                ? this.selectedCreationType.value
                : "PRODUCT";
        },
        changeManufacturer(event) {
            this.inputObj.manufacturerId = this.currentProvider
                ? this.currentProvider._id
                : null;
        },
    },
    mounted: async function () {
        this.loading = true;
        this.inputObj.productType = this.selectedProductType;
        let userID = this.$store.getters["auth/getUserID"];
        if (this.userRole === "Partner") {
            await this.$store
                .dispatch("tenant/getTenantDetailByID", this.userTenantId)
                .then((response) => {
                    if (response && response.response) {
                        this.enableManufacturer = response.response.preferences
                            ? response.response.preferences.enableManufacturer
                            : false;
                        if (this.enableManufacturer) {
                            this.$store.dispatch(
                                "partner/fetchPartnersListByType",
                                "MANUFACTURER",
                            );
                        }
                    }
                });
            await this.getPartnerPaymentPreferencesAction(
                this.$currentUserData._id,
            );
            if (
                this.getPartnerPaymentPreferencesGetter.preferences.buySell.sell
                    .b2b == true &&
                this.getPartnerPaymentPreferencesGetter.preferences.buySell.sell
                    .b2c == false
            ) {
                this.typeB2b = {
                    text: "Sell to Merchant",
                    value: 1,
                };
            } else if (
                this.getPartnerPaymentPreferencesGetter.preferences.buySell.sell
                    .b2b == false &&
                this.getPartnerPaymentPreferencesGetter.preferences.buySell.sell
                    .b2c == true
            ) {
                this.typeB2b = {
                    text: "Sell to Customer",
                    value: 0,
                };
            } else if (
                this.getPartnerPaymentPreferencesGetter.preferences.buySell.sell
                    .b2b == true &&
                this.getPartnerPaymentPreferencesGetter.preferences.buySell.sell
                    .b2c == true
            ) {
                this.typeB2b = {
                    text: "Sell to Both",
                    value: 2,
                };
            }
        }
        this.inputObj.provider = userID;
        this.inputObj.catalogId = this.$route.params.id;
        this.getCatalog();
        if (this.userRole === "Tenant") {
            this.Getpartnerlist();
        }
        this.getImageLibraryList(this.inputObj.catalogId);
        this.loading = false;
    },
    computed: {
        ...mapGetters({
            tenantLang: "tenant/GetTenantLanguage",
            imageLibraryList: "catalog/GetImageLibraryList",
            getPartnerPaymentPreferencesGetter:
                "partner/getPartnerPaymentPreferencesGetter",
            partnerAllData: "partner/GetPartnerData",
        }),
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
        userTenantId() {
            return JSON.parse(sessionStorage.getItem("userLogin"))["tenant"];
        },
        partnerList() {
            let data = this.$store.getters["partner/GetPartnerList"];
            let partnerList = [];
            if (this.enableManufacturer && this.userRole === "Partner") {
                if (Array.isArray(data) && data.length > 0) {
                    data.map((obj) => {
                        let arrayObj = {
                            _id: obj._id,
                            userName: obj.authentication.userName,
                            email: obj.authentication.email,
                            phone: obj.authentication.phone,
                            ...obj,
                        };
                        if (obj.category === "MANUFACTURER") {
                            partnerList.push(arrayObj);
                        }
                    });
                    return partnerList;
                } else {
                    return [];
                }
            } else {
                if (Array.isArray(data) && data.length > 0) {
                    data.map((obj) => {
                        let arrayObj = {
                            _id: obj._id,
                            userName: obj.authentication.userName,
                            email: obj.authentication.email,
                            phone: obj.authentication.phone,
                            ...obj,
                        };
                        partnerList.push(arrayObj);
                    });
                    return partnerList;
                } else {
                    return [];
                }
            }
        },
        selectB2b() {
            return [
                {
                    text: "Sell to Customer",
                    value: 0,
                },
                {
                    text: "Sell to Merchant",
                    value: 1,
                },
                {
                    text: "Sell to Both",
                    value: 2,
                },
            ];
        },
        addressObj() {
            return this.$store.getters["item/GetCurrentCatalogLocation"];
        },
        isService() {
            if (
                this.catalogObj.variations.length > 0 &&
                this.catalogObj.variations.some(
                    (obj) => obj.attrRef.attributeName === "slotTitle",
                )
            ) {
                return true;
            } else {
                return false;
            }
        },
        catalogVariations() {
            if (this.catalogObj.variations.length > 0) {
                let objj = this.catalogObj.variations.filter((obj) => {
                    if (obj.attrRef.attributeName === "Quantity") {
                        return obj;
                    }
                });
                return objj;
            }
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.card-wrap {
    border: none !important;
    box-shadow: 0px 0px 10px 1px rgb(235, 235, 235) !important;
    border-radius: 1px !important;
}

.flex-row {
    display: flex;
}

.wrap {
    margin: 10px;
}

.head {
    font-size: 1.2em;
    font-weight: 900;
}

.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: "Lato";
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: small;
}

.border-blue {
    border: 4px solid lightskyblue;
}

.card-title {
    font-size: 1em;
    font-weight: 800;
    padding-left: 14px;
    padding-top: 10px;
}
</style>
